import React, { Component } from 'react';
import { createPortal } from 'react-dom';

import CoinBrowser from '../CoinBrowser';
import CryptoWatch from '../CryptoWatch';
import CoinTable from '../CoinTable';
import CryptoStrap from '../CryptoStrap';

const MOBILE_VIEWPORT = 600;
const UPDATE_INTERVAL = 30 * 1000;

const standaloneModules = {
  cryptowatch: CryptoWatch,
  'coin-browser': CoinBrowser,
  'coin-table': CoinTable,
  'ticker': CryptoStrap,
};

class CryptoSpace extends Component {
  static defaultProps = {
    baseCurrencySymbol: 'AUD',
    topCoinsNumber: 10,
  }

  nodes = {}

  topCoinsInterval = null;
  scrollEventsCounter = 0;
  initialBrowserScroll = 7;

  createModulePortal = moduleName => {
    const moduleNode = document.querySelector(`.crypto__${moduleName}`);

    if (!moduleNode) {
      return null;
    }

    if (!moduleNode.dataset.erased) {
      moduleNode.innerHTML = '';
      moduleNode.dataset.erased = true;
    }

    const ModuleComponent = standaloneModules[moduleName];
    const moduleProps = {
      ...this.props,
      ...this.state,
    };
    this.nodes[moduleName] = moduleNode;

    return createPortal(
      <ModuleComponent {...moduleProps} />,
      this.nodes[moduleName],
    );
  }

  fetchTopCoins = async () => {
    const { baseCurrencySymbol: currency, topCoinsNumber: perPage } = this.props; 
    const response = await fetch(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency.toLowerCase()}&order=market_cap_desc&per_page=${perPage}&sparkline=true`);

    return await response.json();
  }

  updateTopCoins = async () => {
    const topCoinsData = await this.fetchTopCoins();

    const lastUpdateDateString = new Date().toLocaleString(undefined, {
      timeZoneName: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    const extendedTopCoins = topCoinsData.map(data => {
      const coin = {...data, ...{ symbol: data.symbol.toUpperCase() }};
      const coinEntry = this.props.coinDictionary[coin.symbol];

      if (!coinEntry) {
        return coin;
      }

      const { pageLink, externalId } = coinEntry;

      const extendedCoinData = {
        ...coin,
        externalId,
        pageLink,
      };

      return extendedCoinData;
    });

    this.setState({ topCoins: extendedTopCoins, lastUpdateDateString });
  }

  lazyLoadTopCoins = () => {
    // Prevent default browser scrolls if page was scrolled before realod
    if (this.scrollEventsCounter < this.initialBrowserScroll) {
      this.scrollEventsCounter++;
      return;
    }

    setTimeout(this.updateTopCoins, 1000);
    window.removeEventListener('scroll', this.lazyLoadTopCoins);
    this.topCoinsInterval = setInterval(this.updateTopCoins, UPDATE_INTERVAL);
  };

  handleTopCoins = () => {
    if (window.innerWidth > MOBILE_VIEWPORT) {
      this.updateTopCoins();
      this.topCoinsInterval = setInterval(this.updateTopCoins, UPDATE_INTERVAL);
    } else {
      window.addEventListener('scroll', this.lazyLoadTopCoins);
    }
  }

  componentDidMount() {
    this.handleTopCoins();
  }

  componentWillUnmount() {
    clearInterval(this.topCoinsInterval);
  }

  render() {
    const portals = Object.keys(standaloneModules)
      .map(this.createModulePortal)
      .filter(Boolean);

    return portals;
  }
}

export default CryptoSpace;



// WEBPACK FOOTER //
// ./src/Space/index.js